import * as Yup from 'yup';

const MatchDaySchema = Yup.object().shape({
  employee: Yup.object().shape({
    person: Yup.object().shape({
      name: Yup.string().required('Informe o nome completo'),
      identify: Yup.string().required('Informe o CPF ou Documento de identificação exterior'),
      roleId: Yup.string().required('Informe a função do colaborador'),
    }),
    company: Yup.string().required('Necessário vincular empresa ao colaborador'),
    status: Yup.string().required('Selecione o Status'),
    credentialNumber: Yup.string().required('Selecione o Status'),
    checkInArea: Yup.string().required('Selecione a área de acesso'),
  }),
});

export default MatchDaySchema;
